import styled from '@emotion/styled'
import { Background } from 'react-imgix'
import { colors, media, space } from '@mindfulchefuk/design-system'

export const SearchCategorySlider = styled.section`
  .slick-dots {
    position: static;
    margin: 0;
    padding: ${space[16]} 0;
  }

  .slick-dots li button {
    width: ${space[14]};
    height: ${space[14]};
    background: ${colors['pepper-100']};
    border-radius: 50%;

    &:before {
      display: none;
    }
  }

  .slick-dots li {
    margin: 0 ${space[8]};
  }

  .slick-dots li.slick-active button {
    background: ${colors.aubergine};
  }

  ${media.md} {
    display: none;
  }
`

export const SearchCategoryImage = styled(Background)`
  position: relative;
  display: flex;
  align-items: flex-end;
  width: 100%;
  height: 400px;
  padding: 22px 30px;

  ${media.md} {
    height: 475px;
  }

  &:before {
    content: '';
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50%;
    opacity: 0.8;

    background-image: linear-gradient(
      to bottom,
      rgba(54, 54, 54, 0) 6%,
      #110a29 67%
    );
  }
`
